class RechargeWidget {
    constructor() {
        this.initObserver();
        this.initPurchaseOptionToggle();
        this.initSellingPlanButtons();
    }

    initObserver() {
        const observer = new MutationObserver((mutationsList, observer) => {
            const firstLabel = document.querySelector('.rc-template__radio label.rc-radio');
            const sellingPlansDiv = document.querySelector('.rc-selling-plans');
            const widgetWrapper = document.querySelector('.rc-widget');
            const subscriptionText = document.querySelector('.rc-radio__subscription');
            const subscriptionElement = document.querySelector('.rc-radio__label');
            const subscriptionOptions = document.querySelectorAll('.rc-selling-plans-dropdown__select option');
            const subscriptionRadio = document.querySelector(".rc-radio input[type='radio']");
            const customSubscriptionOptions = document.getElementById("custom-subscription-options");
            const subscriptionHeading = document.querySelector(".rc-section-heading");

            if (firstLabel && sellingPlansDiv && widgetWrapper) {
                observer.disconnect();
                this.addIntroParagraph(widgetWrapper);
                this.wrapElements(firstLabel, sellingPlansDiv);
                this.populateFrequencyOptions(subscriptionOptions);
                this.setupSubscriptionToggle(subscriptionRadio, customSubscriptionOptions, subscriptionHeading);
                this.updateWidgetPrice();
            }

            if (subscriptionText) {
                const text = subscriptionText.textContent;
                const saveText = text.match(/save\s\d+%/i)?.[0] || '';
                const cleanText = text.replace('&', '').replace(saveText, '').trim();
                subscriptionText.textContent = cleanText;
                const saveSpan = document.createElement('span');
                saveSpan.classList.add('rc-save');
                if (saveText == '') {
                    saveSpan.style.display = 'none';
                }
                saveSpan.textContent = saveText;
                subscriptionElement.appendChild(document.createTextNode(' '));
                subscriptionElement.appendChild(saveSpan);
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

         
    }
  
    updateWidgetPrice() {
        const oneTimePriceContainer = document.querySelector(".rc-widget .onetime-radio .rc-radio__label");
        const subsPriceContainer = document.querySelector(".rc-widget .subscription-radio .rc-radio__price");
        const subsPrice = document.querySelector('.rc-widget .rc-radio.subscription-radio .rc-radio__price')?.textContent;
        const oneTimePrice = document.querySelector('[js-atc-price]').getAttribute('data-variant-price');
        const oneTimePriceWithoutDiscount = document.querySelector('[js-atc-price]').getAttribute('data-variant-without-discount-price');
        const oneTimeComparePrice =  document.querySelector('[js-atc-price]').getAttribute('data-variant-compare-price');
         if(oneTimePriceContainer) {
            oneTimePriceContainer.innerHTML = `One time purchase <span class="original">${oneTimePrice}</span><span class="compare">${oneTimeComparePrice}</span>`;
         }
        if(subsPriceContainer) {
            subsPriceContainer.innerHTML = `<span class="original">${subsPrice}</span><span class="compare">${oneTimePriceWithoutDiscount}</span>`;
        }
    }
  
    setupSubscriptionToggle(subscriptionRadio, customSubscriptionOptions, subscriptionHeading) {
        if (!subscriptionRadio || !customSubscriptionOptions || !subscriptionHeading) return;
        const oneTimeRadio = document.querySelector(".onetime-radio input[type='radio']");
const subsPrice = document.querySelector('.rc-widget .rc-radio.subscription-radio .rc-radio__price')?.textContent;
        const toggleVisibility = () => {


          
          const oneTimePrice =  document.querySelector('[js-atc-price]').getAttribute('data-variant-price');
          const oneTimePriceWithoutDiscount = document.querySelector('[js-atc-price]').getAttribute('data-variant-without-discount-price');
          const oneTimeComparePrice =  document.querySelector('[js-atc-price]').getAttribute('data-variant-compare-price');
          const regularPriceContainer = document.querySelector('[js-normal-price]');
          const comparePriceContainer = document.querySelector('[js-compare-price]');
          
         
            if (subscriptionRadio.checked) {
                customSubscriptionOptions.style.display = "flex";
                subscriptionHeading.style.display = "block";
                this.updateSellingPlanSelection();

                if(subsPrice) {
                    regularPriceContainer.innerHTML = subsPrice;
                    comparePriceContainer.innerHTML = oneTimePriceWithoutDiscount;
                }

            } else {
                customSubscriptionOptions.style.display = "none";
                subscriptionHeading.style.display = "none";

                regularPriceContainer.innerHTML = oneTimePrice;
                comparePriceContainer.innerHTML = oneTimeComparePrice;
            }
        };

        toggleVisibility();
        subscriptionRadio.addEventListener("change", toggleVisibility);
        if (oneTimeRadio) {
            oneTimeRadio.addEventListener("change", toggleVisibility);
        }
    }

    populateFrequencyOptions(subscriptionOptions) {
        const customContainer = document.getElementById("custom-subscription-options");
        if (!customContainer) return;
    
        subscriptionOptions.forEach(option => {
            const button = document.createElement("button");
            button.textContent = option.textContent.trim();
            button.classList.add("subscription-button");
            button.dataset.value = option.value;
    
            if (option.selected) {
                button.classList.add("active");
            }
    
            button.addEventListener("click", function () {
                subscriptionOptions.forEach(opt => opt.selected = false);
                option.selected = true;
                option.dispatchEvent(new Event("change", { bubbles: true }));
                document.querySelectorAll(".subscription-button").forEach(btn => btn.classList.remove("active"));
                button.classList.add("active");
            });
    
            customContainer.appendChild(button);
        });
    }    
        
    addIntroParagraph(widgetWrapper) {
        const introParagraph = document.createElement('div');
        introParagraph.textContent = window.rechargeSectionHeading;
        introParagraph.classList.add('rc-section-heading');
        widgetWrapper.parentNode.insertBefore(introParagraph, widgetWrapper);
    }

    wrapElements(firstLabel, sellingPlansDiv) {
        const wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('rc-widget-wrapper');
        firstLabel.parentNode.insertBefore(wrapperDiv, firstLabel);
        wrapperDiv.appendChild(firstLabel);
        const deliveryPlansWrapper = document.createElement('div');
        deliveryPlansWrapper.classList.add('rc-delivery-plans-wrapper');
        const paragraph = document.createElement('p');
        paragraph.innerHTML = window.rechargeProductDescription;
        paragraph.classList.add('rc-delivery-info');
        deliveryPlansWrapper.appendChild(paragraph);
        deliveryPlansWrapper.appendChild(sellingPlansDiv);
        wrapperDiv.appendChild(deliveryPlansWrapper);
    }

    initPurchaseOptionToggle() {
        const subscriptionRadio = document.querySelector("input[name='purchaseOption'][value='subscription']");
        const onetimeRadio = document.querySelector("input[name='purchaseOption'][value='onetime']");
    
        const subscribeSection = document.querySelector("#subscribePurchaseSection label");
        const onetimeSection = document.querySelector("#onetimePurchaseSection label");
    
        const frequencyContainer = document.querySelector(".selling-plan-buttons");
        const frequencyContainerHeading = document.querySelector(".rc-section-heading");
    
        const togglePurchaseSections = () => {
            if (subscriptionRadio && subscriptionRadio.checked) {
                if (frequencyContainer && frequencyContainerHeading) {
                    frequencyContainer.setAttribute("style", "display: flex !important;");
                    frequencyContainerHeading.setAttribute("style", "display: block !important;");
                }
                if (subscribeSection) {
                    subscribeSection.classList.add("rc-radio--active");
                }
                if (onetimeSection) {
                    onetimeSection.classList.remove("rc-radio--active");
                }
                this.updateSellingPlanSelection();
            } else if (onetimeRadio && onetimeRadio.checked) {
                if (frequencyContainer && frequencyContainerHeading) {
                    frequencyContainer.style.display = "none";
                    frequencyContainerHeading.style.display = "none";
                }
                if (onetimeSection) {
                    onetimeSection.classList.add("rc-radio--active");
                }
                if (subscribeSection) {
                    subscribeSection.classList.remove("rc-radio--active");
                }
                this.updateOnetimeSelection();
            }
        };
    
        if (subscriptionRadio) {
            subscriptionRadio.addEventListener("change", togglePurchaseSections);
        }
        if (onetimeRadio) {
            onetimeRadio.addEventListener("change", togglePurchaseSections);
        }
    
        if (subscribeSection) {
            subscribeSection.addEventListener("click", () => {
                if (subscriptionRadio) subscriptionRadio.checked = true;
                togglePurchaseSections();
            });
        }
        if (onetimeSection) {
            onetimeSection.addEventListener("click", () => {
                if (onetimeRadio) onetimeRadio.checked = true;
                togglePurchaseSections();
            });
        }
    
        togglePurchaseSections();
    }

    updateSellingPlanSelection() {
        const newSPContainer = document.querySelector(".selling-plan-buttons");
        if (!newSPContainer) return;
    
        let activeButton = newSPContainer.querySelector(".selling-plan-button.active");
        if (!activeButton) {
            activeButton = newSPContainer.querySelector(".selling-plan-button");
            if (activeButton) {
                activeButton.classList.add("active");
            }
        }
        if (!activeButton) return;
    
        const newSellingPlanValue = activeButton.getAttribute("data-selling-plan-id");
        const newProductId = activeButton.getAttribute("data-subscription-product-id");
        const newProductType = activeButton.getAttribute("data-subscription-product-type");
        const addToCartForm = document.querySelector("product-form form[action='/cart/add']");
        if (addToCartForm) {
            let newSPInput = addToCartForm.querySelector("input[name='selling_plan']");
            let productIdInput = addToCartForm.querySelector("input[name='id']");
            let newProductTypeInput = addToCartForm.querySelector("input[name='type']");
            if (!newSPInput) {
                newSPInput = document.createElement("input");
                newSPInput.type = "hidden";
                newSPInput.name = "selling_plan";
                addToCartForm.appendChild(newSPInput);
            }
            newSPInput.value = newSellingPlanValue;
            if (productIdInput) {
                productIdInput.value = newProductId;
            }
            if (newProductTypeInput) {
                newProductTypeInput.value = newProductType;
            }
        }
    }

    updateOnetimeSelection() {
        const addToCartForm = document.querySelector("product-form form[action='/cart/add']");
        const initialProductType = document.querySelector('#onetimePurchaseSection').getAttribute('data-product-type');
        if (addToCartForm) {
            let productIdInput = addToCartForm.querySelector("input[name='id']");
            let spInput = addToCartForm.querySelector("input[name='selling_plan']");
            let productTypeInput = addToCartForm.querySelector("input[name='type']");
            if (!productIdInput) {
                productIdInput = document.createElement("input");
                productIdInput.type = "hidden";
                productIdInput.name = "id";
                addToCartForm.appendChild(productIdInput);
            }
            productIdInput.value = window.mainProductVariant || "";
            if (spInput) {
                spInput.value = "";
            }
            if (productTypeInput) {
                productTypeInput.value = initialProductType;
            }
        }
    }

    initSellingPlanButtons() {
        const newSPContainer = document.querySelector(".selling-plan-buttons");
        if (!newSPContainer) return;
    
        newSPContainer.querySelectorAll(".selling-plan-button").forEach(button => {
            button.addEventListener("click", () => {
                newSPContainer.querySelectorAll(".selling-plan-button").forEach(btn => btn.classList.remove("active"));
                button.classList.add("active");
    
                const newSellingPlanValue = button.getAttribute("data-selling-plan-id");
                const newProductId = button.getAttribute("data-subscription-product-id");
                const addToCartForm = document.querySelector("product-form form[action='/cart/add']");
                if (addToCartForm) {
                    let newSPInput = addToCartForm.querySelector("input[name='selling_plan']");
                    let productIdInput = addToCartForm.querySelector("input[name='id']");
                    if (!newSPInput) {
                        newSPInput = document.createElement("input");
                        newSPInput.type = "hidden";
                        newSPInput.name = "selling_plan";
                        addToCartForm.appendChild(newSPInput);
                    }
                    newSPInput.value = newSellingPlanValue;
                    if (productIdInput) {
                        productIdInput.value = newProductId;
                    }
                }
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new RechargeWidget();
});
